import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TipProblema, TipProblemaUpdate } from './tipuri-probleme.interface';

@Injectable({
    providedIn: 'root'
})
export class TipuriProblemeService {
    private basePath = environment.interop.basePath;

    private findUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.find;
    private listUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.list;
    private storeUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.store;
    private updateUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.update;
    private deleteUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.delete;
    private listActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.listActive;
    private listPublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.listPublic;
    private updateActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.updateActive;
    private updatePublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.tipuriProbleme.updatePublic;

    constructor(private http: HttpClient) { }

    find(id: number) {
        return this.http.get(this.findUrl + id);
    }

    list() {
        return this.http.get(this.listUrl);
    }

    add(tipProblema: TipProblema) {
        return this.http.post(this.storeUrl, tipProblema);
    }

    update(tipProblema: TipProblemaUpdate) {
        return this.http.put(this.updateUrl, tipProblema);
    }

    delete(id: number) {
        return this.http.delete(this.deleteUrl + id);
    }

    listActive() {
        return this.http.get(this.listActiveUrl);
    }

    listPublic() {
        return this.http.get(this.listPublicUrl);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.updateActiveUrl + id, {});
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.updatePublicUrl + id, {});
    }
}
